import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FullScreenLoading } from "../../../components/loading";
import { Modal } from "../../../components/modal";
import ToolsHeader from "../components/header";
import ToolsSidebar from "./components/sidebar";
import { ToolsWrapper, ToolsBody, ToolsContainer } from "../style";
import ResponsiveFix from "../../../components/responsiveFix";
const WalletForm = React.lazy(() =>
  import("../../../containers/tools/wallet/form")
);
const BankAccountForm = React.lazy(() =>
  import("../../../containers/tools/bankAccount/form")
);
const ToolsForm = React.lazy(() =>
  import("../../../containers/tools/tools/form")
);
const ContactForm = React.lazy(() =>
  import("../../../containers/tools/contact/form")
);
const ConstructionPhaseForm = React.lazy(() =>
  import("../../../containers/tools/constructionPhase/form")
);
const ConstructionComponentForm = React.lazy(() =>
  import("../../../containers/tools/constructionComponent/form")
);

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

    let modalComponent, modalIcon;
    if (props.route.location.pathname.indexOf("/wallet") !== -1) {
      modalComponent = <WalletForm closeModal={this.closeModal} />;
      modalIcon = "icon mapsa-empty-opened-wallet";
    } else if (props.route.location.pathname.indexOf("/bank-account") !== -1) {
      modalComponent = <BankAccountForm closeModal={this.closeModal} />;
      modalIcon = "icon mapsa-bank";
    } else if (props.route.location.pathname.indexOf("/tools") !== -1) {
      modalComponent = <ToolsForm closeModal={this.closeModal} />;
      modalIcon = "icon mapsa-bank";
    } else if (props.route.location.pathname.indexOf("/contact") !== -1) {
      modalComponent = <ContactForm closeModal={this.closeModal} />;
      modalIcon = "icon mapsa-new-user";
    } else if (
      props.route.location.pathname.indexOf("/construction-phase") !== -1
    ) {
      modalComponent = <ConstructionPhaseForm closeModal={this.closeModal} />;
      modalIcon = "icon mapsa-new-user";
    } else if (
      props.route.location.pathname.indexOf("/construction-component") !== -1
    ) {
      modalComponent = (
        <ConstructionComponentForm closeModal={this.closeModal} />
      );
      modalIcon = "icon mapsa-new-user";
    }

    this.state = {
      showModal: false,
      modalIcon: modalIcon,
      modalComponent: modalComponent
    };
  }

  openModal() {
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  render() {
    const { showModal, modalComponent, modalIcon } = this.state;
    const { Component, route } = this.props;
    const Sidebar = (this.props.options && this.props.options.sidebar) || {};

    return (
      <ResponsiveFix>
        <ToolsHeader />
        <ToolsWrapper>
          <ToolsSidebar
            onAddClick={this.openModal}
            addButton={Sidebar.addButton}
            menu={Sidebar.menu}
            SubComponent={Sidebar.subComponent}
          />
          <ToolsBody>
            <ToolsContainer>
              <Suspense fallback={<FullScreenLoading />}>
                <Component route={route} />
              </Suspense>
              <Modal
                show={showModal}
                title="صندوق جدید"
                icon={modalIcon}
                closeHandler={this.closeModal}
                width="330px"
                header={{
                  title: "",
                  icon: modalIcon,
                  iconColor: "primary_vivid"
                }}
              >
                <Suspense fallback={<FullScreenLoading />}>
                  {modalComponent}
                </Suspense>
              </Modal>
            </ToolsContainer>
          </ToolsBody>
        </ToolsWrapper>
      </ResponsiveFix>
    );
  }
}

const mapStateToProps = state => {
  return {
    headerData: state.Init.data.data || []
  };
};

export default withRouter(connect(mapStateToProps)(Dashboard));
